var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0237 3.39453C10.162 3.39453 7.02368 6.53286 7.02368 10.3945V13.7662C7.02368 14.4779 6.72035 15.5629 6.35868 16.1695L5.01701 18.3979C4.18868 19.7745 4.76035 21.3029 6.27701 21.8162C11.3053 23.4962 16.7303 23.4962 21.7587 21.8162C23.1703 21.3495 23.7887 19.6812 23.0187 18.3979L21.677 16.1695C21.327 15.5629 21.0237 14.4779 21.0237 13.7662V10.3945C21.0237 6.54453 17.8737 3.39453 14.0237 3.39453Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1799 3.73172C15.8183 3.62672 15.4449 3.54505 15.0599 3.49839C13.9399 3.35839 12.8666 3.44005 11.8633 3.73172C12.2016 2.86839 13.0416 2.26172 14.0216 2.26172C15.0016 2.26172 15.8416 2.86839 16.1799 3.73172Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5234 22.2383C17.5234 24.1633 15.9484 25.7383 14.0234 25.7383C13.0668 25.7383 12.1801 25.3416 11.5501 24.7116C10.9201 24.0816 10.5234 23.1949 10.5234 22.2383",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconWhite);
export default __webpack_public_path__ + "static/media/notification_icon_white.1f030e118409e916a0a74ec19eb9968d.svg";
export { ForwardRef as ReactComponent };